import React from 'react';
import includes from 'lodash/includes';
import kebabCase from 'lodash/kebabCase';
import styled from 'styled-components';
import { ProductMetaData } from '../../../models/Product';

const StTeaser = styled.div`
    font-style: italic;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;
`;

type Props = {
    readonly product: Pick<ProductMetaData, 'supplementaries' | 'teaser'>;
    readonly types: string[];
    readonly isLibx?: boolean;
};

export const ProductSupplementaries = ({ product: { supplementaries = [], teaser }, types, isLibx = false }: Props) => {
    if (isLibx) {
        return <StTeaser>{teaser}</StTeaser>;
    }

    const filteredSupplementaries = supplementaries.filter(supplementary => includes(types, supplementary.type));

    return (
        <div>
            {filteredSupplementaries.map((supplementary, index) => {
                const typeClassName = `supplementary ${kebabCase(supplementary.type)}`;

                return (
                    <div key={typeClassName + index} className={typeClassName}>
                        {supplementary.information}
                        <span className="source">{supplementary.source}</span>
                    </div>
                );
            })}
        </div>
    );
};
